export default "__VITE_PUBLIC_ASSET__513c2e88__"